import { Environment } from '@dice/app/types/env.type';
import { INT_ENV_CONFIG } from '@dice/environments/int/int.env';
import { NgxLoggerLevel } from 'ngx-logger';

export const INT_MASTERDATA_ENV_CONFIG: Environment = {
  ...INT_ENV_CONFIG,
  hostNames: ['dice-int-masterdata.scapp-corp.swisscom.com', 'localhost:2000'],
  enableDebugInfo: true,
  isProduction: false,
  variant: 'dice-ui-int-masterdata',
  logLevel: NgxLoggerLevel.DEBUG,

  wsEndpoint: `wss://buda-message-proxy-int.scapp-corp.swisscom.com/`,
  wsEndpointForUCCP: `wss://buda-message-proxy-uccp-int.scapp-corp.swisscom.com/`,
  budaConfigurationEndpoint: `https://buda-masterdata-int.scapp-corp.swisscom.com/`,
  budaStatisticsConsumerEndpoint: 'https://buda-message-proxy-int.scapp-corp.swisscom.com/',
  budaStatisticsConsumerEndpointForUCCP: 'https://buda-message-proxy-uccp-int.scapp-corp.swisscom.com/',
  agentViewStatisticsConsumerEndpoint: `https://buda-message-proxy-agentview-int.scapp-corp.swisscom.com/`,
  agentInfoStatisticsConsumerEndpoint: `https://buda-message-proxy-agentinfo-int.scapp-corp.swisscom.com/`,
};
